import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "transport",
  ref: "transport_ref",
  class: "transport col-12 px-0 d-none d-md-flex my-4 font-body font-size-16 font-weight-default"
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "title-container d-flex justify-content-between" }
const _hoisted_4 = { class: "title-4 text-grey-800 mb-2" }
const _hoisted_5 = { class: "tabs-wrapper d-flex flex-row nowrap mt-4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "tab-inner-wrapper" }
const _hoisted_8 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_9 = { class: "d-flex justify-content-center align-items-center" }

import { nextTick, computed, ComputedRef } from "vue"
//import store from "@/vue/planning/store/store"
import RadioCircle from "@/vue/common/radioCircle.vue"

// computed
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"
import availableNonTransportPackageCodes from "@/vue/planning/computed/availableNonTransportPackageCodes"

// config
import colors from "@/config/colors"

import { useStore } from "vuex"

export default /*@__PURE__*/_defineComponent({
  __name: 'transportSwitch',
  setup(__props) {

const store = useStore();

class SwitchOption {
	label: string
	value: boolean
	constructor(label: string, value: boolean) {
		this.label = label
		this.value = value
	}
}

// computed
const options: ComputedRef<SwitchOption[]> = computed(() => {
	const { content } = store.state
	const switchOptions: SwitchOption[] = []

	const switchContent: string = store.getters.flightPackCodeSelected ? content.planner_formulaWithFlight : content.planner_formulaWithTransport
	switchOptions.push(
		new SwitchOption(switchContent, true)
	)

	// If we have other options besides a train pack, add the switch to select not transport packs
	if (
		availableNonTransportPackageCodes.value &&
		availableNonTransportPackageCodes.value.length
	) {
		switchOptions.push(new SwitchOption(content.planner_noTransport, false))
	}

	return switchOptions
})



// methods
const handleSwitch = (bool: boolean) => {
	store.commit("setTransport", bool)
	store.commit("setTransportationSelected", bool)
	store.dispatch("selectTransportWithDefaultPackage", bool)
	// nextTick(() => {
		store.dispatch("setPackage", packagesToDisplay.value[0].codePackage)
		// store.dispatch("selectTransportWithDefaultPackage", bool)
	// })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString("1. ") + _toDisplayString(_unref(store).state.content.planner_optForPackages), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, option_i) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: _withModifiers(($event: any) => (handleSwitch(option.value)), ["stop"]),
            class: _normalizeClass(["tab col", 
						_unref(store).state.transportCheckbox === option.value
							? 'active font-weight-700'
							: ''
					]),
            key: option_i
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(RadioCircle, {
                  active: _unref(store).state.transportCheckbox === option.value,
                  colorDefault: _unref(colors).darkBlue,
                  colorActive: 'white',
                  additionalClasses: 'me-1 me-xl-3'
                }, null, 8, ["active", "colorDefault"])
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(option.label), 1)
            ])
          ], 10, _hoisted_6))
        }), 128))
      ])
    ])
  ], 512))
}
}

})